"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary-light via-background to-secondary-light">
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517379/img/lab_research_background.png)"
    }} />

      <div ref={ref} className={`relative z-10 w-full max-w-4xl px-6 text-center transition-all duration-[var(--duration-fast)] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h1 className="font-display font-bold text-foreground !text-5xl ![margin:72px_0px_16px_0px]">Understand Your Medical Results</h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Clear, evidence-based explanations of laboratory values and biomarkers.
        </p>

        <Link to="/LabValuesPage" className="inline-flex items-center justify-center rounded-sm bg-accent text-foreground-accent px-6 py-3 font-semibold shadow-soft hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-dark active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] mb-6">Browse Lab Values</Link>

        <p className="text-muted-foreground mt-6 !text-base">
          Blood tests and lab reports can be confusing. We explain what common lab values and biomarkers usually mean - in clear, evidence-based language, written for patients and their caretakers.
        </p>
      </div>
    </section>;
}